import { makeStyles } from '@material-ui/core/styles';

export const textDefault = (theme) => ({
  color: theme.palette.text.primary,
  textTransform: 'uppercase',
});

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2.5rem',
    backgroundColor: theme.palette.container.border,
  },
}));

export default useStyles;
